import { useQuery } from '@tanstack/react-query';
import { getDeal, getPlacementInfo } from './bx24';
import type { CrmDeal } from './types';

export function useDeal() {
  return useQuery<CrmDeal, Error>({
    queryKey: ['deal'],
    queryFn: async () => {
      const info = await getPlacementInfo();
      const dealId = info.options?.ID;
      if (!dealId) {
        throw new Error('placement.info() не вернул ID сделки');
      }
      return getDeal(dealId);
    },
    retry: 2,
    staleTime: 30_000,
  });
}
